<template>
  <div class="wjAppointmentEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回审核列表</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="到访日期" prop="visitTime">
          <el-input type="text" v-model="ruleForm.visitTime" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="到访人员姓名" prop="visitName">
          <el-input type="text" v-model="ruleForm.visitName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="到访人员单位" prop="visitUnit">
          <el-input type="text" v-model="ruleForm.visitUnit" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="到访人员手机" prop="visitPhone">
          <el-input type="text" v-model="ruleForm.visitPhone" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="到访人员身份证号" prop="visitIdCard">
          <el-input type="text" v-model="ruleForm.visitIdCard" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="入场时间" prop="inTime">
          <el-input type="text" v-model="ruleForm.inTime" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="访问时长(小时)" prop="visitOfTime">
          <el-input type="text" v-model="ruleForm.visitOfTime" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="是否携带物品" prop="isGoods">
          <el-radio-group v-model="ruleForm.isGoods">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item tem label="物品简介" prop="goodsInfo">
          <el-input type="text" v-model="ruleForm.goodsInfo" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="是否开车" prop="isCar">
          <el-radio-group v-model="ruleForm.isCar">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item tem label="车牌号码" prop="carNum">
          <el-input type="text" v-model="ruleForm.carNum" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="被访人员姓名" prop="beVisitName">
          <el-input type="text" v-model="ruleForm.beVisitName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="被访人员部门" prop="beVisitDepartment">
          <el-input type="text" v-model="ruleForm.beVisitDepartment" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="被访人员电话" prop="beVisitPhone">
          <el-input type="text" v-model="ruleForm.beVisitPhone" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="来访事由" prop="visitReason">
          <el-input type="textarea" :rows="8" v-model="ruleForm.visitReason" disabled class="item-input"></el-input>
        </el-form-item>
        <!-- <el-form-item tem label="核酸检测证明" prop="fj1" v-if="ruleForm.fj1">
          <viewer :images="this.ruleForm.fj1">
            <img v-for="(src,index) in this.ruleForm.fj1" :src="src" :key="index"
              style="width: 100px; height: 100px; margin-right: 20px;" />
          </viewer>

        </el-form-item> -->
        <!-- <el-form-item tem label="辽事通健康码" prop="fj11" v-if="ruleForm.fj11">
          <viewer :images="this.ruleForm.fj11">
            <img v-for="(src,index) in this.ruleForm.fj11" :src="src" :key="index"
              style="width: 100px; height: 100px; margin-right: 20px;" />
          </viewer>
        </el-form-item> -->
        <!-- <el-form-item tem label="大数据行程码" prop="fj12" v-if="ruleForm.fj12">
          <viewer :images="this.ruleForm.fj12">
            <img v-for="(src,index) in this.ruleForm.fj12" :src="src" :key="index"
              style="width: 100px; height: 100px; margin-right: 20px;" />
          </viewer>
        </el-form-item> -->
        <!-- 按钮 -->
        <el-button class="btn-first" type="danger" @click="showdialog()"
          :disabled="ruleForm.state==2||ruleForm.state==3">拒绝</el-button>
        <el-button class="detailbtn" type="primary" @click="adopt()" :disabled="ruleForm.state==2||ruleForm.state==3">通过
        </el-button>
      </el-form>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <el-input rows=4 type="textarea" v-model="refuseReason" placeholder="请输入拒绝原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="refuse()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:wjAppointmentEdit
   *@Description:万洁预约审批详情
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        ruleForm: {},
        dialogVisible: false, // 拒绝弹框
        refuseReason: '', // 拒绝原因
      }
    },
    computed: {
      ...mapGetters(['gardenId']),
    },
    created() {
      this.getData()
    },
    watch: {

    },
    methods: {

      // 业主通知编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        this.ruleForm = this.$route.query.object
        // this.ruleForm.fj1 = this.ruleForm.fj1.split(',')
        // this.ruleForm.fj11 = this.ruleForm.fj11.split(',')
        // this.ruleForm.fj12 = this.ruleForm.fj12.split(',')
        console.log(this.ruleForm)
      },
      // 审核通过
      adopt() {
        let loading = this.$loading()
        let params = {
          state: 2
        }
        this.$confirm('通过该访客预约申请？', '提示', {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'success'
          }).then(() => {
            this.$patch(`/wjSubscribe/${this.ruleForm.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  console.log(res)
                  this.$message({
                    type: 'success',
                    message: '已通过审批'
                  })
                  this.$router.push({
                    name: 'wjAppointmentExamine'
                  })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: '已取消审批'
            })
          })
      },
      // 审核不通过
      refuse() {
        if (this.refuseReason == '') {
          this.$message({
            type: 'info',
            message: '请输入拒绝原因'
          })
        } else {
          let loading = this.$loading()
          let params = {
            state: 3,
            checkInfo: this.refuseReason
          }
          this.$patch(`/wjSubscribe/${this.ruleForm.id}`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.dialogVisible = false
                this.$message({
                  type: 'error',
                  message: '已拒绝审批'
                })
                this.$router.push({
                  name: 'wjAppointmentExamine'
                })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            })
        }
      },
      // 显示拒绝弹窗
      showdialog() {
        this.dialogVisible = true
      },
      // 返回上一级
      back() {
        // this.$router.push({
        //   name: 'wjAppointmentExamine'
        // })
        this.$router.back()
      },

    },
  }
</script>

<style lang="scss">
  .wjAppointmentEdit {
    .item-input {
      width: 30%;
    }

    .el-input.is-disabled .el-input__inner {
      color: #000;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block;
    }

    .empty-input {
      display: none;
    }

    .el-textarea.is-disabled .el-textarea__inner {
      color: #000;
    }
  }
</style>